<template>
  <div class="modal fade create-new-user-modal" id="CreateCategoryModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Criar categoria</h1>
                  <button type="button" class="btn-close create-new-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formCreateCategory" @submit.prevent="createCategoryMethod">
                <div class="modal-body ps-30 pe-30">
                  <div v-if="errorMessage" class="alert alert-danger fs-md-15 fs-lg-16" role="alert">
                    {{ errorMessage }}
                  </div>
                  <p>Preencha as informações abaixo para criar uma categoria</p>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_category_created" class="form-label fw-medium"
                      >Categoria</label
                    >
                    <input
                      type="text"
                      class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                      id="name_category_created"
                      placeholder="Digite a categoria"
                      autocomplete="off"
                      required
                      v-model="categoryName"
                    />
                  </div>

                  <!-- active/inactive flag -->
                  <div class="form-check mb-20 col-12">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="active_category_created"
                      v-model="isActive"
                    />
                    <label class="form-check-label" for="active_category_created">
                      Categoria ativa
                    </label>
                  </div>

                  <div class="mb-20 col-12">
                    <label class="form-label fw-medium">Usuários vinculados</label>

                    <div v-if="availableUsers.length" class="border rounded-2 p-15" style="max-height: 260px; overflow-y: auto;">
                      <div
                        v-for="user in availableUsers"
                        :key="user.id"
                        class="form-check mb-12"
                      >
                        <input
                          :id="`create-category-user-${user.id}`"
                          v-model="selectedUserIds"
                          :value="user.id"
                          class="form-check-input"
                          type="checkbox"
                        />
                        <label class="form-check-label d-block" :for="`create-category-user-${user.id}`">
                          <span class="fw-medium text-black-emphasis">{{ user.name }}</span>
                          <small class="d-block text-body-tertiary">{{ user.email || user.phone || 'Sem contato cadastrado' }}</small>
                        </label>
                      </div>
                    </div>

                    <div v-else class="border rounded-2 p-15 text-body-tertiary">
                      Nenhum usuário disponível para vincular.
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                    <button type="submit" ref="buttonCreateCategory" class="btn btn-success">Criar categoria</button>
                  </div>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from 'vuex';
import api from '../../config/axios.js';

export default defineComponent({
  name: "CreateCategoryModal",
  computed: {
    ...mapGetters([
      "getAllUsersList"
    ]),
    availableUsers() {
      const allUsersList = (this as any).getAllUsersList;
      return Array.isArray(allUsersList) ? allUsersList : [];
    }
  },
  data() {
    return {
      categoryName: '',
      isActive: true,
      selectedUserIds: [] as number[],
      errorMessage: ''
    };
  },
  methods: {
    ...mapActions([
      "fetchCategories"
    ]),
    async createCategoryMethod() {
      const buttonCreateCategory = this.$refs.buttonCreateCategory as HTMLButtonElement;
      this.errorMessage = '';
      buttonCreateCategory.disabled = true;
      buttonCreateCategory.innerHTML = "Salvando...";

      try {
        const response = await api.axios.post('/api/category/create', {
          name: this.categoryName,
          active: this.isActive,
          user_ids: this.selectedUserIds
        });
        if (response.status === 200) {
          buttonCreateCategory.innerHTML = "Categoria criada com sucesso!";
          window.location.reload();
        }
      } catch (error) {
        console.error('Erro ao criar categoria:', error);
        const backendError = (error as any)?.response?.data;
        this.errorMessage =
          backendError?.message ||
          (typeof backendError === 'string' ? backendError : '') ||
          'Erro ao criar categoria.';
        buttonCreateCategory.disabled = false;
        buttonCreateCategory.innerHTML = "Criar";
      }
    }
  }
});
</script>
